<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{student.name}}</h1>
        </div>
        <table class="table">
            <thead>
                <tr>
                    <th>{{$t('evaluations.diploma')}}</th>
                    <th>{{$t('evaluations.level')}}</th>
                    <th class="table__cell--icon"></th>
                </tr>
            </thead>
            <tbody>
                <tr @click="showChart(student.id, diploma)" v-for="(diploma, index) in student.diplomas" :key="`diploma_${diploma.id}_${index}`">
                    <td>{{diploma.title}}</td>
                    <td>{{diploma.level}}</td>
                    <td>
                        <span v-if="!diploma.has_evaluations" v-tooltip.right="$t('evaluations.no_evaluations')" class="table__icon icons icon-chart"></span>
                        <span v-else @click="showChart(student.id, diploma)" v-tooltip.right="$t('evaluations.view_chart')" class="table__icon icons icon-chart"></span>
                    </td>
                </tr>
            </tbody>
        </table>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    @Component({
        components: {}
    })
    export default class DiplomasModal extends Vue {
        student = { diplomas: [{}] };
        name = 'diplomas-modal';

        beforeOpen(event) {
            this.student = event.params.student;
            if (this.student.diplomas.length == 1) {
                this.showChart(this.student.id, this.student.diplomas[0]);
            }
        }

        showChart(user_id, diploma) {
            if (diploma.has_evaluations) this.$router.push({ name: 'chart', params: { user_id: user_id, diploma_id: diploma.diploma_id }});
        }
    }

    Vue.component('diplomas-modal', DiplomasModal);
</script>



// WEBPACK FOOTER //
// src/components/modals/evaluations/DiplomasModal.vue